<template>
  <el-container class="co-nabizime">

    <div style="text-align: center; max-width: 900px; padding-bottom: 20px">
      <h1>Nabízené služby</h1>
    </div>

    <div class="nabidka-karty">
        <karta-nabidka class="nabidka-karta" v-for="n in nabidka" :key="n" :card="n" @click="goTo(n.url)" />
    </div>
  </el-container>
</template>

<script>
import { useRouter } from 'vue-router'

import KartaNabidka from "./KartaNabidka.vue"



export default {
    name: "CoNabizime",
    components: {
      KartaNabidka
    },
    setup(){
      const router = useRouter();
      const goTo = function(url){
        router.push(url)
      }

      let nabidka = [
        {
          "ic": "/icons/cessna.png",
          "nazev": "Zážitkové lety",
          "text": "Nabízíme lety z letiště Kroměříž podle Vašich požadavků. Trasu si můžete naplánovat po celé ČR a SR.",
          "url": "/zazitkovelety"
        },
        {
          "ic": "/icons/origami.png",
          "nazev": "Pilotem na zkoušku",
          "text": "Pilotování si u nás můžete také vyzkoušet pod dohledem zkušeného letce!",
          "url": "/zazitkovelety#pilotemnazkousku"
        },
        {
          "ic": "/icons/pilot.png",
          "nazev": "Pilotní výcvik",
          "text": "Chcete začít létat? U nás můžete získat pilotní průkaz na větroně a ultralehké letouny.",
          "url": "/#vycvik"
        },
        {
          "ic": "/icons/hangar.png",
          "nazev": "Členství",
          "text": "Chcete létat pravidelně a využívat výhod členství v našem aeroklubu? Přidejte se k nám!",
          "url": "/clenstvi"
        }
      ]
      return {nabidka, goTo}
    }
}
</script>


<style scoped>

.co-nabizime {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  /* height: 600px; */
  width: 100%;
  /* background: rgb(219, 245, 255); */
  padding-bottom: 40px;
  padding-top: 40px;
}

.nabidka-karty{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 5px;
  max-width: 1400px;
  /* background: rgb(219, 255, 255); */

}

.nabidka-karta{
  margin: 10px;
  transition: .2s;
}
.nabidka-karta:hover{
  transform: scale(1.05);
  margin-left: 20px;
  margin-right: 20px;
}

</style>